import PropTypes from "prop-types";
import MetaTags from "react-meta-tags";
import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Card, CardBody, Container, Label } from "reactstrap";
// import { useSearchParams } from "react-router-native";
// import queryString from 'query-string';
// import axios from "axios";
import { del, get, post, put } from "../../helpers/api_helper"

import { env } from '../../env'

//redux
import { useDispatch } from "react-redux";

import { withRouter, Link, useLocation } from "react-router-dom";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";

const GuestComplimentary = props => {
  const { search } = useLocation();

  const searchParams = useMemo(() => new URLSearchParams(search), [search]);

  const [message, setMessage] = useState();
  const [error, setError] = useState();
  useEffect(() => {

    post(process.env.REACT_APP_API_URL + 'auth/complimentary/grant', {
      guestId: searchParams.get('guestId'),
      status: searchParams.get('status'),
      approvedBy: searchParams.get('approvedBy')
    }).then((res) => {
      if (res?.success) {
        setMessage(res?.message);
      } else {
        setError(res?.message);
      }
    }).catch((e) => {
      setError(e.message);
    });
  }, []);

  const statusHandler = () => {
    if (error) {
      return (<Label className="alert alert-danger">OOps...! {error ? error : "Something went wrong... Please try again or contact site admin"}</Label>);
    } else {
      return (<Label className="alert alert-success">{message ? message : "Guest has been granted access: Without Complimentary Access"}</Label>);
    }
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>
          Guest Complimentary Access Athorization | CPF Parking System
        </title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-softbg-soft-primary">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-white">Guest Complimentary Access Athorization</h5>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <div className="mb-3">
                      {(message||error) && statusHandler()}
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} CPF Parking System.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

GuestComplimentary.propTypes = {
  history: PropTypes.object,
};

export default withRouter(GuestComplimentary);
